// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1o-7";
export var adjustableWidthBorderHeld = "_1o-8";
export var arrow = "_1o-3";
export var arrowButton = "_1o-4";
export var headerCell = "_1o-0";
export var help = "_1o-2";
export var icon = "_1o-1";
export var iconWrapper = "_1o-6";
export var noBorder = "_1o-b";
export var nonAdjustableWidthBorder = "_1o-9";
export var nonAdjustableWidthBorderHeld = "_1o-a";
export var textButton = "_1o-5";